import { useQuery } from '@tanstack/react-query';
import { vehicleRegistrationKeys } from '../services/queryKeys';
import { fetchVehicleMileage } from '../services/vehicleRegistration';
import { isClientError } from './useVehicleRegistrationQuery';

/** A 403 is the server's settled answer, so an ungated caller spends one request and not four. */
export function useVehicleMileage(vehicleId: string | undefined, options: { staleTime?: number } = {}) {
    return useQuery({
        ...options,
        queryKey: vehicleRegistrationKeys.mileage(vehicleId ?? ''),
        queryFn: () => fetchVehicleMileage(vehicleId!),
        enabled: !!vehicleId,
        retry: (count, error) => !isClientError(error) && count < 2,
    });
}
